import {Injectable} from '@angular/core';
import SecureLS from "secure-ls";

@Injectable({
  providedIn: 'root',
})
export class StorageService {

  private ls = new SecureLS({encodingType: 'aes', isCompression: true});

  set(key: string, value: any, expired: number = 0) {
    this.ls.set(key, value);
  }

  remove(key: string) {
    this.ls.remove(key);
  }

  get(key: string) {
    try {
      return this.ls.get(key);
    } catch (error) {
      console.error('Failed to fetch from local storage');
      return null;
    }
  }

  clear() {
    this.ls.removeAll();
  }

  clearStorage() {
    localStorage.clear();
  }
}
